import React from 'react'
import '../assets/Head_Img.css';

class Head_Img extends React.Component {
  render() {
    return (
     <div className="banner">
        <div className="write-up">
          <p data-aos="zoom-in-up" data-aos-duration="10000"><font><b>NEW COLLECTION</b></font></p>
           <h1><b>Beautifully<br />Crafted Modern<br />Furniture</b></h1>
              <p>asethic is our recognition.</p>
        <a href="#"><button className="button">Explore Now</button></a>
     </div>
   </div>
    )
  }
}

export default Head_Img;